"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firebase = require("firebase");
/*
 * Class
 */
const Codable_1 = require("./Codable");
exports.Codable = Codable_1.Codable;
const Field_1 = require("./Field");
exports.Field = Field_1.Field;
const File_1 = require("./File");
exports.File = File_1.File;
const SubCollection_1 = require("./SubCollection");
exports.SubCollection = SubCollection_1.SubCollection;
const Model_1 = require("./Model");
exports.Model = Model_1.Model;
const Document_1 = require("./Document");
exports.Doc = Document_1.Doc;
const Collection_1 = require("./Collection");
exports.Collection = Collection_1.Collection;
const Batch_1 = require("./Batch");
exports.Batch = Batch_1.Batch;
exports.initialize = (appFirestore, root) => {
    exports.firestore = appFirestore;
    exports.rootReference = root || exports.firestore;
};
exports.CollectionReference = firebase.firestore.CollectionReference;
exports.DocumentReference = firebase.firestore.DocumentReference;
exports.DocumentSnapshot = firebase.firestore.DocumentSnapshot;
exports.FieldPath = firebase.firestore.FieldPath;
exports.FieldValue = firebase.firestore.FieldValue;
exports.Firestore = firebase.firestore.Firestore;
exports.GeoPoint = firebase.firestore.GeoPoint;
exports.Query = firebase.firestore.Query;
exports.QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;
exports.QuerySnapshot = firebase.firestore.QuerySnapshot;
exports.Timestamp = firebase.firestore.Timestamp;
exports.Transaction = firebase.firestore.Transaction;
exports.WriteBatch = firebase.firestore.WriteBatch;
//# sourceMappingURL=index.js.map